"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.nodeType = void 0;
exports.nodeType = 'file_orgProvidedInput';
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database. (well not completely,
// because it may be modified by synthetic node creation later)
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
exports.artifactType = 'orgProvidedInput';
//# sourceMappingURL=types.js.map